import { Text } from "@clipboard-health/ui-components";
import { Button } from "@src/appV2/redesign/components/Button";
import { BaseTierCard } from "@src/appV2/redesign/Tiers/Cards/BaseTierCard";
import { SilverTierCardWrapper } from "@src/appV2/redesign/Tiers/Cards/SilverTierCardWrapper";
import { TIERS_FULL_PATH } from "@src/appV2/redesign/Tiers/paths";
import { TIERS_PERKS_SECTION_ID } from "@src/appV2/redesign/Tiers/utils/constants";
import { useHistory } from "react-router-dom";

export function SilverTierHeaderSection() {
  const history = useHistory();

  return (
    <SilverTierCardWrapper>
      <BaseTierCard
        title="You're a Silver Member"
        content={
          <Text variant="body1" textAlign="left">
            Work your way up to Gold and unlock exclusive perks!
          </Text>
        }
        footer={
          <Button
            invert
            variant="contained"
            size="medium"
            endIconType="chevron-right"
            sx={{ width: "fit-content" }}
            onClick={() => {
              history.replace(`${TIERS_FULL_PATH}#${TIERS_PERKS_SECTION_ID}`);
            }}
          >
            Learn More
          </Button>
        }
      />
    </SilverTierCardWrapper>
  );
}
